<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="date"
                            v-model="filtro.referencia">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-building-o fa-fw" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-filter fa-fw"
                            type="select"
                            placeholder="Todos os Centros de Custo..."
                            :optionsList="lista_centros_filtro"
                            optionsData="id_centro_custo"
                            :validate="validate"
                            :edicao="lista_centros_filtro.length"
                            v-model="filtro.id_centro_custo" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Externo"
                            v-model="filtro.externo" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Hospital..."
                            icon="fas fa-clinic-medical fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="centro_cirurgicos.index"
                            optionsData="id_centro_cirurgico" 
                            optionsDisplay="st_centro_cirurgico"
                            :optionsParm="{ ativos: true }"
                            :edicao="filtro.externo"
                            v-model="filtro.id_centro_cirurgico"  />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input icon="fa fa-search fa-fw" v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Incluir Escala">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum escala identificada.'" 
                icon="fas fa-calendar-day" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            <span v-if="dado.tipo.fl_externo && dado.centro">
                                {{ dado.centro.st_centro_cirurgico }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            </span>

                            {{ dado.search }}

                            <span v-if="dado.centro_custo">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ dado.centro_custo.st_nome }}
                            </span>
                        </a>
                        <small v-if="dado.unidade_operacao && dado.unidade_operacao.st_sigla" class="badge badge-light mx-1">
                          {{ dado.unidade_operacao.st_sigla }}
                        </small>
                        <div class="text-muted small">
                            <span>
                                {{ $util.getFormatDate(dado.dt_vigencia_inicio) }}
                                -
                                {{ $util.getFormatDate(dado.dt_vigencia_fim) }}
                            </span>
                            <span class="ml-3">
                                {{ dado.hr_inicio }} - {{ dado.hr_termino }}
                                <i class="fas fa-stopwatch ml-3"></i>
                                {{ dado.duracao }}h
                            </span>
                        </div>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else class="text-right">
                            <span class="badge ml-3" :class="'badge-' + dado.tipo.st_color">
                                {{ dado.in_necessidade}}
                            </span>
                            <div v-if="dado.js_classes">
                                <span class="badge ml-1" :class="'badge-' + dado.tipo.st_color" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                    {{ classe }}
                                </span>
                            </div>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_plantao_agenda ? '' : 'Novo' }}
                            Escala
                            <span class="badge badge-secondary" v-if="item && item.id_plantao_agenda">
                                #{{ item.id_plantao_agenda }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    :edicao="!item.id_plantao_agenda"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo"
                                    type="select"
                                    optionsMode="aql"
                                    service="plantao_tipos.index"
                                    optionsData="id_plantao_tipo"
                                    :edicao="!item.id_plantao_agenda"
                                    required
                                    :validate="validate"
                                    v-model="item.id_plantao_tipo"
                                    @input="atualizar_tipo()">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.tipo">
                                            <span class="input-group-text" :class="item.tipo.st_color ? 'text-' + item.tipo.st_color : ''" id="basic-addon2">
                                                <i class="fa fa-building-o" v-if="!item.tipo.fl_externo"></i>
                                                <i class="fas fa-external-link-alt" v-else></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6" v-if="lista_centros.length > 1">
                                <az-input
                                    label="Centro de Custo"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="lista_centros"
                                    optionsData="id_centro_custo"
                                    :validate="validate"
                                    v-model="item.id_centro_custo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Quantidade"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.in_necessidade" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    :type="trocando_valor ? 'number' : 'money'"
                                    label="Valor Padrão"
                                    v-model="item.dc_valor_plantao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Local"
                                    type="select"
                                    optionsMode="aql"
                                    service="centro_cirurgicos.index"
                                    optionsData="id_centro_cirurgico"
                                    :optionsParm="{ ativos: true }"
                                    :edicao="!item.id_plantao_agenda"
                                    required
                                    :validate="validate"
                                    v-model="item.id_centro_cirurgico" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Início da Vigência"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_vigencia_inicio" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Término da Vigência"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_vigencia_fim" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário de Entrada"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="item.hr_inicio" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário de Saída"
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="item.hr_termino" />
                            </div>
                        </div>

                        <div class="row" v-if="item.js_dias_da_semana">
                            <div class="col col-12 d-flex flex-column">
                                <div class="btn-group input-group-sm mt-2 mb-2" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" 
                                        :class="dia ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="toggle_dia(idia)"
                                        v-for="(dia, idia) in item.js_dias_da_semana" :key="idia">
                                        {{ nome_dia(idia) }}
                                        <i class="fa fa-check ml-2" v-if="dia" aria-hidden="true"></i>
                                        <i class="fa fa-times ml-2" v-else aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-sub-title class="mt-1" title="Classificação Requerida" />
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <az-sub-title class="mt-1" title="Procedimentos" />
                        <div v-if="!item.procedimentos.length" class="mb-3 small text-muted">
                            Nenhum Procedimento Selecionado.
                        </div>

                        <div v-else>
                            <div v-for="(proced, ipx) in item.procedimentos" :key="ipx">
                                <az-input
                                    v-show="!proced.excluido"
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="proced.procedimento.search">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="proced.excluido = true">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div>
                            <az-input 
                                sizing="sm"
                                placeholder="Selecione o procedimento..."
                                icon="fas fa-plus"
                                type="autocomplete" 
                                service="procedimentos.index"
                                optionsMode="aql"
                                optionsName="procedimentos.index" 
                                :optionsSync="false"
                                v-model="busca_procedimento"
                                ref="info_procedimento"
                                @input="selecionarProcedimento ()" />
                        </div>

                        <br><br><br><br><br><br><br><br><br><br>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="plantaoAgenda" :id="item.id_plantao_agenda" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_plantao_agenda ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            options_classes: [],
            trocando_valor: false, 
            filtro: { 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                id_centro_custo: "", 
                search: "",
                referencia: this.$util.hoje(), 
                externo: true, 
                id_centro_cirurgico: "", 
            }, 
            busca_procedimento: "", 
        }
    },

    props: ['local'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        Multiselect
    },

    computed: { 
        lista_centros: function () { 
            
            if ( !this.item || !this.item.id_unidade_operacao ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.item.id_unidade_operacao);

            return und ? und.centro_custos : [];

        },

        lista_centros_filtro: function () { 
            
            if ( !this.filtro || !this.filtro.id_unidade_operacao ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

            return und ? und.centro_custos : [];

        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.filtro.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.filtro.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        selecionarProcedimento() { 
            if ( !this.busca_procedimento )
                return;

            let proc = _.cloneDeep(this.busca_procedimento);
            this.busca_procedimento = "";

            this.$nextTick(() => { 
                this.item.procedimentos.push({
                    excluido: false, 
                    procedimento: proc,
                });

                this.busca_procedimento = null;
            });
        },

        atualizar_tipo () { 
            let lista = this.$store.state.options['plantao_tipos.index'];

            if ( lista ) { 
                this.item.tipo = lista.find(pt => pt.id_plantao_tipo == this.item.id_plantao_tipo);

                if ( this.item.tipo && !this.item.id_plantao_agenda ) { 
                    this.trocando_valor = true; 

                    this.$nextTick(() => { 
                        // this.item.dc_valor_plantao = this.item.tipo.dc_valor_plantao;
                        this.item.js_classes = this.item.tipo.js_classes;
                        this.trocando_valor = false; 
                    });
                }
            }
        },

        toggle_dia(dia) { 
            this.$set(this.item.js_dias_da_semana, dia, !this.item.js_dias_da_semana[dia]);
        },
        
        nome_dia(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }

            return '?';
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },
        
        incluir () { 
            this.validate = false;
            
            let item = {
                id_plantao_agenda: null, 
                id_unidade_operacao: "", 
                id_plantao_tipo: "", 
                id_centro_cirurgico: "", 
                js_dias_da_semana: [true,true,true,true,true,true,true],
                dc_valor_plantao: null, 
                fl_ativo: true,
                js_classes: [],
                dt_vigencia_inicio: this.$util.hoje(), 
                dt_vigencia_fim: this.$util.hoje(),
                hr_inicio: null,
                hr_termino: null, 
                st_obs: "", 
                procedimentos: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'plantao_agendas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                    ...this.filtro, 
                    tipo_referencia: 'D',
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
        
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'plantao_agendas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'plantao_agendas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Escalas", path: "/escalas/escalas"},
                { name: "Escalas", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>